// https://github.com/xigua1994/react-tiga-swiper/blob/master/README.zh-cn.md
import React, { Component, useRef, useState } from 'react'


import "./index.css";
import classNames from 'classnames'
import { BsyUtils } from "../../../utils/Utils";
import BsyDashBase from "../../dash/BsyDashBase";
import BsyComboBox from "../../BsyComboBox";
import BsyAlertMenu from "../../BsyAlertMenu";
import BsyMsgBubble from '../../../components/BsyMsgBubble';
import { WindowPropsContext, windowProp } from '../../dash/component_context.js';

// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component

/**
 * 
 */
export class BsyFilteQuick extends BsyDashBase {
    static contextType = WindowPropsContext;
    constructor(props) {
        super(props);
        this.state = {
            combineFilterModel: props.combineFilterModel,
            combineFilter: JSON.parse(JSON.stringify(props.combineFilterModel.combineFilter).replace(/title/g, 'text').replace(/_combineId/g, 'value')),
            value: '',
            copyCombineFilter: [],
            morecopyCombineFilter: [],
            chooseCombinerFilter: [],
            eleWidth: 0,
            comboBox: 200,
            moreText: React.language("more"),
        };
        this.quikerRefElement = React.createRef();
        this.comboBoxRef = React.createRef();
        this.timer = 1
        this.oldUpselect = "" //记录combo类型选择的id
    }

    componentDidMount() {
        let _this = this
        this.quikerComponents = []
        BsyUtils.forEach(this.props.allComponentDash.entry.components, function (t, i) {
            if (i.type === "filte_quick") {
                _this.quikerComponents.push(i)
            }
        })
        //不清楚为啥要加上才能显示带数据图标
        if (this.props.getContext) {
            this.props.getContext(this);
        }

        let valueOk = this.state.combineFilter.filter((item, key) => {
            return item.select
        })
        if(valueOk.length > 0){
            this.oldUpselect = valueOk[0].value
        }
        this.setState({
            value: valueOk.length > 0 ? valueOk[0].value : '',
            chooseCombinerFilter: valueOk || []
        })
        this.quikerRefElement.current && setTimeout(function () { //渲染拿不到外层宽高
            _this.compuitdQukeritem()
        }, 40)
    }
    compuitdQukeritem = () => {
        let ret = BsyUtils.closestClass(this.quikerRefElement.current, 'filte_quick');
        let _width = ret.style.width.slice(0, ret.style.width.length - 2) - 20

        let _height = window.$(this.quikerRefElement.current).parents('.t-quick-pc-content').height() - 18
        let combineFilter = JSON.parse(JSON.stringify(this.state.combineFilter))
        let morecopyCombineFilter = []
        let length = this.state.combineFilter.length
        let _keyW = 1
        let _keyH = parseInt(_height / 40) || 1;
        let eleW = ''
        !this.state.combineFilterModel.select && window.$(ret).find('.block-head ').hide()

        if (_width <= 100) {
            eleW = "100%"
        } else {
            BsyUtils.forEach(combineFilter, function (key, item) {
                if (_width / (key + 1) > 100 && _width / (key + 1) < 200) {
                    _keyW = key + 1
                }
                if (combineFilter.length * 200 < _width) {
                    _keyW = combineFilter.length
                }
            })
            // if (_keyH >= 2) {
            //     _keyW = Math.ceil(length / _keyH)
            // }
            eleW = _width / _keyW - 9 + 'px'
            // if(_keyH ===1){
            //     _keyW = combineFilter.length
            // }
        }
        if (_keyW * _keyH < length) {
            morecopyCombineFilter = JSON.parse(JSON.stringify(this.state.combineFilter)).slice(_keyW * _keyH - 1)
            combineFilter = combineFilter.slice(0, _keyW * _keyH - 1)
        }
        this.setState({
            copyCombineFilter: combineFilter,
            eleWidth: eleW,
            comboBox: _width,
            morecopyCombineFilter: morecopyCombineFilter
        })
        console.log("_width", _width)
    }
    chooseMore = (event) => {
        let chooseCombinerFilter = this.state.chooseCombinerFilter
        let bts = [];
        let _this = this;

        this.state.morecopyCombineFilter.map((res, index) => {
            bts.push({
                icon: '',
                text: res.text,
                selected: res.select,
                click: () => {
                    let copyCombineFilter = this.state.copyCombineFilter
                    let morecopyCombineFilter = this.state.morecopyCombineFilter
                    let moreText = this.state.moreText






                    copyCombineFilter.map((item) => {
                        if (item.select) {
                            item.select = false
                        }
                        return item
                    })
                    if (chooseCombinerFilter.length > 0 && chooseCombinerFilter[0].value === res.value) { //重复选择
                        BsyUtils.forEach(morecopyCombineFilter, (key, item) => {
                            item.select = false
                        })
                        BsyUtils.forEach(_this.quikerComponents, function (keyC, itemC) {
                            if (itemC.widgetId === _this.props.widgetId) {
                                BsyUtils.forEach(itemC.combineFilterModel.combineFilter, function (key1, item1) {
                                    item1.select = false
                                })
                            }
                        })


                        chooseCombinerFilter = []
                        _this.context.upOverallSituationValue('quikerComponents', _this.quikerComponents)
                        BsyUtils.applyFunc(_this, _this.props.onChooseUpItem, [res.value, _this.props.widgetId, 'delete'], !1);
                        moreText = '更多'
                    } else {
                        BsyUtils.forEach(_this.quikerComponents, function (keyC, itemC) {
                            if (itemC.widgetId === _this.props.widgetId) {
                                BsyUtils.forEach(itemC.combineFilterModel.combineFilter, function (key1, item1) {
                                    if (item1._combineId === res.value) {
                                        item1.select = true
                                    } else {
                                        item1.select = false
                                    }
                                })
                            }
                        })
                        BsyUtils.forEach(morecopyCombineFilter, (key, item) => {
                            if (key === index) {
                                item.select = true
                                chooseCombinerFilter = [item]
                                _this.context.upOverallSituationValue('quikerComponents', _this.quikerComponents)
                                BsyUtils.applyFunc(_this, _this.props.onChooseUpItem, [item.value, _this.props.widgetId, 'updata'], !1);
                            } else {
                                item.select = false
                            }
                        })



                        moreText = res.text
                    }



                    this.setState({
                        copyCombineFilter: copyCombineFilter,
                        morecopyCombineFilter: morecopyCombineFilter,
                        chooseCombinerFilter: chooseCombinerFilter,
                        moreText: moreText
                    })

                }
            })
        })

        BsyAlertMenu({
            item: bts,
            width: 150,
            target: event.target,
            customCls: 'data-manage-batch-menu',
        })
    }
    debounce = (ms, fn) => {
        let _this = this
        if (this.timer) {
            clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
            if (this.timer) {
                fn()
            }
            this.timer = null;
        }, ms);
    }
    chooseItem = (event, index, item) => {
        let _this = this
        let copyCombineFilter = this.state.copyCombineFilter
        let morecopyCombineFilter = this.state.morecopyCombineFilter
        let chooseCombinerFilter = this.state.chooseCombinerFilter
        // this.debounce(100, function (t, odd) {
           
        // })
        init()
        function init() {
            if (chooseCombinerFilter.length > 0 && item.value === chooseCombinerFilter[0].value) {
                BsyUtils.forEach(copyCombineFilter, (key, item) => {
                    chooseCombinerFilter = []
                    item.select = false
                })
                BsyUtils.forEach(_this.quikerComponents, function (keyC, itemC) {
                    if (itemC.widgetId === _this.props.widgetId) {
                        BsyUtils.forEach(itemC.combineFilterModel.combineFilter, function (key1, item1) {
                            item1.select = false
                        })
                    }
                })
                _this.context.upOverallSituationValue('quikerComponents', _this.quikerComponents)
                BsyUtils.applyFunc(_this, _this.props.onChooseUpItem, [item.value, _this.props.widgetId, 'delete'], !1);
            } else {
                BsyUtils.forEach(copyCombineFilter, (key, item) => {
                    if (key === index) {
                        item.select = true
                        chooseCombinerFilter = [item]
                    } else {
                        item.select = false
                    }
                })


                BsyUtils.forEach(_this.quikerComponents, function (keyC, itemC) {
                    if (itemC.widgetId == _this.props.widgetId) {
                        BsyUtils.forEach(itemC.combineFilterModel.combineFilter, function (key1, item1) {
                            if (item1._combineId === item.value) {
                                item1.select = true
                            } else {
                                item1.select = false
                            }
                        })
                    }
                })
                _this.context.upOverallSituationValue('quikerComponents', _this.quikerComponents)
                BsyUtils.applyFunc(_this, _this.props.onChooseUpItem, [item.value, _this.props.widgetId, 'updata'], !1);
            }
            morecopyCombineFilter.map((item) => {
                if (item.select) {
                    item.select = false
                }
                return item
            })
          
            _this.setState({
                copyCombineFilter: copyCombineFilter,
                morecopyCombineFilter: morecopyCombineFilter,
                chooseCombinerFilter: chooseCombinerFilter,
                moreText: React.language("more")
            })
        }
    }
    setDefaultConfig() {
        this.componentDidMount()
    }
    clearConfig() {
        let _this = this;
        let combineFilter = JSON.parse(JSON.stringify(this.state.combineFilter))
        let copyCombineFilter = JSON.parse(JSON.stringify(this.state.copyCombineFilter))
        let morecopyCombineFilter = JSON.parse(JSON.stringify(this.state.morecopyCombineFilter))

        BsyUtils.forEach(combineFilter, (key, item) => {
            item.select = false
        })

        BsyUtils.forEach(copyCombineFilter, (key, item) => {
            item.select = false
        })
        BsyUtils.forEach(morecopyCombineFilter, (key, item) => {
            item.select = false
        })

        this.setState({
            value: '',
            combineFilter: combineFilter,
            copyCombineFilter: copyCombineFilter,
            morecopyCombineFilter: morecopyCombineFilter,
            chooseCombinerFilter: []
        })
        setTimeout(() => { //BsyComboBox清除不掉，暂无时间找原因
            this.setState({
                value: '',
            })
        }, 20)
    }
    onChooseUpItem(t, sec, context) {
        let _this = this
        if (t) {
            BsyUtils.forEach(_this.quikerComponents, function (keyC, itemC) {
                if (itemC.widgetId === _this.props.widgetId) {
                    BsyUtils.forEach(itemC.combineFilterModel.combineFilter, function (key1, item1) {
                        if (item1._combineId === t) {
                            item1.select = true
                            _this.oldUpselect = t
                        } else {
                            item1.select = false
                        }
                    })
                }
            })
            this.context.upOverallSituationValue('quikerComponents', _this.quikerComponents)
            BsyUtils.applyFunc(this, this.props.onChooseUpItem, [t, this.props.widgetId, 'updata'], !1);
        } else {
            BsyUtils.forEach(_this.quikerComponents, function (keyC, itemC) {
                if (itemC.widgetId === _this.props.widgetId) {
                    BsyUtils.forEach(itemC.combineFilterModel.combineFilter, function (key1, item1) {
                        item1.select = false
                    })
                }
            })
            this.context.upOverallSituationValue('quikerComponents', _this.quikerComponents)
            BsyUtils.applyFunc(this, this.props.onChooseUpItem, [this.oldUpselect, this.props.widgetId, 'delete'], !1);
        }
        this.setState({
            value: t
        })

    }
    hoverEnterPanel = (event, item) => {
        this.adp = BsyMsgBubble({
            anchor: event.currentTarget,
            dockPosition: "center",
            text4Ok: null,
            width: add(item.text) < 50 ? 50 : add(item.text),
            text4Cancel: null,
            edge: 50,
            // hAdjust: add(item.text) / 3,
            contentHTML: () => {
                return (<div className='t-element-tip-quiker'>{item.text}</div>)
            },
        });
        function add(text) {
            const dom = document.createElement('span');
            dom.style.display = 'inline-block';
            dom.textContent = text;
            document.body.appendChild(dom);
            let width = dom.clientWidth;
            document.body.removeChild(dom);
            return width;
        }
    }
    hoverLeavePanel = () => {
        window.$('.bsy-msg-bubble').remove()
    }
    loadData = (n, d) => {
        BsyUtils.applyFunc(this, this.props.onLoadSuccess, [{}, n, d], !1);
    };
    render() {

        return (<>
            <div className={classNames(this.state.combineFilterModel.select ? "t-quick-pc-content t-yes" : "t-quick-pc-content")}>
                {/* {
                    this.state.combineFilterModel.select && <div className='t-pc-title' style={{color:this.props.styles && this.props.styles.fontSetting && this.props.styles.fontSetting.titleColor}}>{this.state.combineFilterModel.title}</div>
                } */}

                {
                    this.state.combineFilterModel.combineFilterType === "card" && <div ref={this.quikerRefElement} className={classNames(this.state.combineFilterModel.select ? "t-pc-card t-has-title" : "t-pc-card")}>
                        {
                            this.state.copyCombineFilter.map((item, index) => {
                                return (<div onClick={(event) => {
                                    this.chooseItem(event, index, item);
                                }} onMouseEnter={(event) => {
                                    this.hoverEnterPanel(event, item)
                                }} onMouseLeave={(event) => {
                                    this.hoverLeavePanel(event)
                                }} style={{ 'width': this.state.eleWidth }} className={classNames(item.select ? "t-select" : "")}>{item.text
                                    }</div>)

                            })
                        }
                        {
                            this.state.morecopyCombineFilter.length > 0 && <div style={{ 'width': this.state.eleWidth }} onClick={(event) => {
                                this.chooseMore(event);
                            }} className={classNames(this.state.morecopyCombineFilter.filter((item) => { return item.select }).length > 0 ? "t-select" : "")}><span>{this.state.moreText}</span><i className='icon-down1 t-more'></i></div>
                        }
                    </div>
                }
                {
                    this.state.combineFilterModel.combineFilterType === "combo" && <div ref={this.quikerRefElement} className={classNames(this.state.combineFilterModel.select ? "t-has-title-combo" : "")}>
                        <BsyComboBox ref={this.comboBoxRef}
                            height={34}
                            items={
                                this.state.combineFilter
                            }
                            allowBlank={!1}
                            upWidth={
                                this.state.comboBox
                            }
                            width='auto'
                            value={this.state.value}
                            onStopEdit={(t, sec, context) => {
                                this.onChooseUpItem(t, sec, context)
                            }}
                            onClose={(t) => {

                            }}
                        />
                    </div>
                }
            </div>

        </>)
    }
}

